import React from 'react'
import Dashboard from './Dashboard'
import Table from "../TableHomeScreen/Index"
const index = ({type}) => {
  return (
    <div className='flex flex-1 flex-col overflow-hidden px-2 md:px-4 pt-2'>
     <div className="flex-shrink-0 flex justify-center">
       <Dashboard />
     </div>
     <div className='flex-1 flex flex-col min-h-0 mt-2 overflow-hidden'> 
      <Table data={type}/>
     </div>
    </div>
  )
}

export default index
